module.exports = __webpack_public_path__ + "static/img/tom.82a25c09.png";